import "bootstrap/dist/css/bootstrap.min.css";
import { Suspense, lazy } from "react";
import { createBrowserRouter } from "react-router-dom";
const Privacy = lazy(() => import("../components/about/Privacy"));
const TermsOfService = lazy(() => import("../components/about/TermsOfService"));
import Login from "../components/auth/Login";
import Login2 from "../components/auth/Login2";
import GoogleCalendarSettings from "../components/integrations/google/GoogleCalendarSettings";
import GoogleMapsSettings from "../components/integrations/google/GoogleMapsSettings";
import QuickbooksSettings from "../components/integrations/QuickbooksSettings";
const JobDetail = lazy(() => import("../components/job/JobDetail"));
const JobEdit = lazy(() => import("../components/job/JobEdit"));
const JobList = lazy(() => import("../components/job/JobList"));
const JobPaverOrders = lazy(
  () => import("../components/job/pavers/JobPaverOrders"),
);
const PaverOrderEdit = lazy(
  () => import("../components/job/pavers/PaverOrderEdit"),
);
import PDFViewer from "../components/job/pdf/PDFViewer";
const LeadDetails = lazy(() => import("../components/lead/LeadDetails"));
const LeadList = lazy(() => import("../components/lead/LeadList"));
const IntegrationsList = lazy(
  () => import("../components/settings/integration/IntegrationsList"),
);
const PricesEdit = lazy(
  () => import("../components/settings/prices/PricesEdit"),
);
const ProposalTemplates = lazy(
  () => import("../components/settings/template/ProposalTemplates"),
);
import SettingsList from "../components/settings/SettingsList";
const UsersEdit = lazy(() => import("../components/settings/user/UsersList"));
import Profile from "../components/user/Profile";
import ErrorPage from "../misc/error-page";
import PrivateRoutes from "./PrivateRoutes";
import InstallerPaymentEdit from "../components/job/installer/InstallerPaymentEdit";
import JobsMapView from "../components/map/JobsMapView";
import Home from "../components/home/Home";
import Test from "../components/lead/Test";
const FormInputs = lazy(
  () => import("../components/settings/formInput/FormInputs"),
);
const LabelsEdit = lazy(
  () => import("../components/settings/label/LabelsEdit"),
);
import Goals from "../components/report/Goals";
const CompanyDetails = lazy(
  () => import("../components/settings/company/CompanyDetails"),
);
import OutlookSettings from "../components/integrations/outlook/OutlookSettings";
import RepairList from "../components/repair/RepairList";
import RepairDetails from "../components/repair/RepairDetails";
import JobRepairList from "../components/repair/JobRepairList";
const ChecklistsEdit = lazy(
  () => import("../components/settings/checklist/ChecklistsEdit"),
);
const JobProgress = lazy(
  () => import("../components/job/progress/JobProgress"),
);
const InstallerPaymentsList = lazy(
  () => import("../components/job/installer/InstallerPaymentsList"),
);
const ToolboxList = lazy(
  () => import("../components/settings/toolbox/ToolboxList"),
);
const LeadsImport = lazy(
  () => import("../components/settings/toolbox/LeadsImport"),
);
const UtilityLocationsEdit = lazy(
  () => import("../components/settings/utility-locations/UtilityLocationsEdit"),
);
import JobInstallerPayments from "../components/job/installer/JobInstallerPayments";
import RootNavBar from "./RootNavBar.";
import JobProgressMap from "../components/job/progress/JobProgressMap";
import PowerBI from "../components/report/PowerBI";
import FormControls from "../components/settings/formInput/FormControls";
import FormDropdowns from "../components/settings/formDropdown/FormDropdowns";
import ProposalDisclaimer from "../components/settings/disclaimer/ProposalDisclaimer";
import ProposalTerms from "../components/settings/disclaimer/ProposalTerms";
import ProductList from "../components/settings/product/ProductList";

const AppRouter = createBrowserRouter([
  {
    path: "/",
    element: <RootNavBar />,
    errorElement: <ErrorPage />,
    // todo find out what loader is for
    // loader: rootLoader,
    children: [
      {
        element: <PrivateRoutes />,
        errorElement: <ErrorPage />,
        children: [
          {
            path: "/",
            element: <Home />,
          },
          {
            path: "home",
            element: <Home />,
          },
          {
            path: "leads",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <LeadList />
              </Suspense>
            ),
          },
          {
            path: "leads/:leadId",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <LeadDetails />
              </Suspense>
            ),
          },
          {
            path: "jobs",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <JobList />
              </Suspense>
            ),
          },
          {
            path: "jobs/progress",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <JobProgress />
              </Suspense>
            ),
          },
          {
            path: "jobs/progress/map",
            element: <JobProgressMap />,
          },
          {
            path: "installer-payments",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <InstallerPaymentsList />
              </Suspense>
            ),
          },
          {
            path: "jobs/:jobId",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <JobDetail />
              </Suspense>
            ),
          },
          {
            path: "jobs/:jobId/edit",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <JobEdit />
              </Suspense>
            ),
          },
          {
            path: "jobs/:id/pdf",
            element: <PDFViewer model="pdf" />,
          },
          {
            path: "jobs/:id/installer",
            element: <PDFViewer model="installer" />,
          },
          {
            path: "jobs/:jobId/pavers",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <JobPaverOrders />
              </Suspense>
            ),
          },
          {
            path: "paver-orders/:orderId/edit",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <PaverOrderEdit />
              </Suspense>
            ),
          },
          {
            path: "paver-orders/:id/pdf",
            element: <PDFViewer model="paver-orders" />,
          },
          {
            path: "settings",
            element: <SettingsList />,
          },
          {
            path: "settings/users",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <UsersEdit />
              </Suspense>
            ),
          },
          {
            path: "settings/integrations",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <IntegrationsList />
              </Suspense>
            ),
          },
          {
            path: "settings/proposal-templates",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <ProposalTemplates />
              </Suspense>
            ),
          },
          {
            path: "settings/proposal-disclaimer",
            element: <ProposalDisclaimer />,
          },
          {
            path: "settings/proposal-terms",
            element: <ProposalTerms />,
          },
          {
            path: "settings/form-inputs",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <FormInputs />
              </Suspense>
            ),
          },
          {
            path: "settings/form-controls",
            element: <FormControls />,
          },
          {
            path: "settings/form-dropdowns",
            element: <FormDropdowns />,
          },
          {
            path: "settings/prices",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <PricesEdit />
              </Suspense>
            ),
          },
          {
            path: "settings/labels",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <LabelsEdit />
              </Suspense>
            ),
          },
          {
            path: "settings/checklists",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <ChecklistsEdit />
              </Suspense>
            ),
          },
          {
            path: "settings/company",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <CompanyDetails />
              </Suspense>
            ),
          },
          {
            path: "settings/toolbox",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <ToolboxList />
              </Suspense>
            ),
          },
          {
            path: "settings/toolbox/leads-import",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <LeadsImport />
              </Suspense>
            ),
          },
          {
            path: "settings/utility-locations",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <UtilityLocationsEdit />
              </Suspense>
            ),
          },
          {
            path: "settings/products",
            element: <ProductList />,
          },
          {
            path: "integrations/quickbooks",
            element: <QuickbooksSettings />,
          },
          {
            path: "integrations/google-calendar",
            element: <GoogleCalendarSettings />,
          },
          {
            path: "integrations/google-maps",
            element: <GoogleMapsSettings />,
          },
          {
            path: "integrations/outlook",
            element: <OutlookSettings />,
          },
          {
            path: "installer-payments/:id",
            element: <InstallerPaymentEdit />,
          },
          {
            path: "jobs/:id/installer-payments",
            element: <JobInstallerPayments />,
          },
          {
            path: "repairs",
            element: <RepairList />,
          },
          {
            path: "repairs/:id",
            element: <RepairDetails />,
          },
          {
            path: "repairs/:id/pdf",
            element: <PDFViewer model="repair" />,
          },
          {
            path: "jobs/:id/repairs",
            element: <JobRepairList />,
          },
          {
            path: "reports/goals",
            element: <Goals />,
          },
          {
            path: "reports/power-bi",
            element: <PowerBI />,
          },
          {
            path: "profile",
            element: <Profile />,
          },
          {
            path: "test",
            element: <Test />,
          },
        ],
      },
    ],
  },
  {
    path: "login",
    element: <Login />,
  },
  {
    path: "login2",
    element: <Login2 />,
  },
  {
    path: "maps/jobs",
    element: <JobsMapView />,
  },
  {
    path: "terms",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <TermsOfService />
      </Suspense>
    ),
  },
  {
    path: "privacy",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <Privacy />
      </Suspense>
    ),
  },
]);

export default AppRouter;
